import { HelpIcon } from './HelpIcon';

export function AddressField({ id, label, value, onChange, error, helpText, required, readOnly }) {
  const addr = typeof value === 'object' && value !== null ? value : {};
  const update = (key, val) => onChange({ ...addr, [key]: val });
  const fieldStyle = { fontSize:'0.7rem', fontWeight:600, color:'#64748b', marginBottom:'4px', display:'block' };
  return (
    <div className="fw" style={{ gridColumn:'1 / -1' }}>
      <label className="fl">
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem', marginTop:'0.5rem', background:'#f8fafc', padding:'1rem', borderRadius:'8px', border:'1px solid #e2e8f0' }}>
        {[
          { key:'line1', label:'Address Line 1', col:'1 / -1', ph:'Street address, P.O. box, etc.' },
          { key:'line2', label:'Address Line 2', col:'1 / -1', ph:'Apartment, suite, unit, etc.' },
          { key:'landmark', label:'Landmark', col:'1 / -1', ph:'E.g. Near Central Park' },
          { key:'city', label:'City', col:null, ph:'City' },
          { key:'state', label:'State / Province', col:null, ph:'State' },
          { key:'country', label:'Country', col:null, ph:'Country' },
          { key:'pincode', label:'Pincode / Zip', col:null, ph:'Zip code' },
          { key:'phone', label:'Phone', col:null, ph:'Contact number' },
        ].map(f => (
          <div key={f.key} style={f.col ? { gridColumn:f.col } : {}}>
            <label style={fieldStyle}>{f.label}</label>
            <input className="field-input" placeholder={f.ph} value={addr[f.key] || ''} readOnly={readOnly} onChange={e => update(f.key, e.target.value)} />
          </div>
        ))}
      </div>
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
